import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import "@fontsource/material-icons";
import App from "./App";
import { setEnvVars } from "./fabrix/redux/settings-slice";
import { store } from "./fabrix/redux/store";
//These must point to the index files to help with load performance and tree shaking
import { LoadingService } from "./fabrix/services/authentication/loading.service";
import { ClientTranslationService } from "./fabrix/services/modules/core/client-translation-service";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { LanguageFile, loadTranslations, locale } from "./fabrix/common/translations";


const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

const getEnvVars = async () => {
  let loadingService = new LoadingService();

  let fabrixServer = process.env.REACT_APP_FABRIX_SERVER?.trim();

  return await loadingService.loadSettings(fabrixServer ?? "/");
};

const getTranslations = async () => {
  const service = new ClientTranslationService();
  return await service.getLocale(locale);
};

getEnvVars().then(async (data) => {

  store.dispatch(setEnvVars(data));

  getTranslations().then((lf: LanguageFile) => {
    loadTranslations(lf);
    root.render(
      <Provider store={store}>
        <React.StrictMode>
          <App />
        </React.StrictMode>
      </Provider>
    );
  });
});


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
